import React from 'react';

/** Props for {@link DataTable}. */
export interface DataTableProps {
  /** Screen-reader heading of the row label column. */
  rowHeader: string;
  /** Column headings after the row label column. */
  columns: string[];
  rows: Array<{ key: string; label: string; cells: Array<string | number> }>;
}

/** The table view of a card: the same values as its chart, as text. */
export const DataTable: React.FC<DataTableProps> = ({ rowHeader, columns, rows }) => (
  <div className="max-h-80 overflow-auto">
    <table className="w-full text-xs">
      <thead>
        <tr className="text-muted-foreground">
          <th scope="col" className="py-1 pr-3 text-left font-normal"><span className="sr-only">{rowHeader}</span></th>
          {columns.map(column => <th key={column} scope="col" className="py-1 pl-3 text-right font-normal">{column}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <tr key={row.key} className="border-t border-border/50">
            <th scope="row" className="max-w-[16rem] truncate py-1 pr-3 text-left font-normal text-foreground" data-tip={row.label} data-tip-truncated>{row.label}</th>
            {row.cells.map((cell, index) => <td key={index} className="py-1 pl-3 text-right tabular-nums text-foreground">{cell}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
